import { action, observable, runInAction, configure } from "mobx";
import { TenantApi, SystemSettingApi } from "apis";
import ApiStore from "./ApiStore";
import BaseStore from "./BaseStore";
import { LANGUAGE_CODE_DEFAULT, RENEWAL_SPAN_CODE_DEFAULT, TENANT_LICENSE_CODE_DEFAULT } from '../core/utils/constants';

configure({ enforceActions: "observed" });

const defaultTenantFormData = {
  name: "",
  language: LANGUAGE_CODE_DEFAULT,
  startDate: null,
  endDate: null,
  applyMonth: null,
  total: null,
  userActive: null,
  renewalSpan: RENEWAL_SPAN_CODE_DEFAULT,
  license: TENANT_LICENSE_CODE_DEFAULT,
  adminId: "",
  adminAccount: "",
  adminPass: "",
  confirmPassword: "",
  teamName: "",
};

class TenantStore extends BaseStore {
  @observable tenants = [];
  @observable fromMonth = null;
  @observable fromYear = null;
  @observable toMonth = null;
  @observable toYear = null;
  @observable total = {};
  @observable active = 'true';
  @observable renewalSpanMonth = 'true';
  @observable renewalSpanYear = 'true';
  @observable licenseEvaluation = 'true';
  @observable licenseFull = 'true';
  @observable keepFilterState = false;
  @observable tenantFormData = defaultTenantFormData;

  constructor(props) {
    super(props);
    this.api = new TenantApi();
    this.fromMonth = (new Date()).getMonth() + 1;
    this.toMonth = (new Date()).getMonth() + 1;
    this.fromYear = (new Date()).getFullYear();
    this.toYear = (new Date()).getFullYear();
  }

  @action
  setTenantFormData = (data) => {
    this.tenantFormData = data;
  }

  @action
  loadDefaultTenantFormData = () => {
    this.tenantFormData = defaultTenantFormData;
  }

  @action
  setFromMonth = (value) => {
    this.fromMonth = value;
  }

  @action
  setToMonth = (value) => {
    this.toMonth = value;
  }

  @action
  setFromYear = (value) => {
    this.fromYear = value;
  }

  @action
  setToYear = (value) => {
    this.toYear = value;
  }

  @action
  setActive = (value) => {
    this.active = value;
  }

  @action
  setRenewalSpanMonth = (value) => {
    this.renewalSpanMonth = value;
  }

  @action
  setRenewalSpanYear = (value) => {
    this.renewalSpanYear = value;
  }

  @action
  setLicenseEvaluation = (value) => {
    this.licenseEvaluation = value;
  }

  @action
  setLicenseFull = (value) => {
    this.licenseFull = value;
  }

  @action
  async getTenants() {
    const { size, page, sortDir, sortKey } = this.paging;
    let payload = {
      size, page, sortDir, sortKey, fromYear: this.fromYear, fromMonth: this.fromMonth,
      toYear: this.toYear, toMonth: this.toMonth, active: this.active,
      renewalSpanMonth: this.renewalSpanMonth, renewalSpanYear: this.renewalSpanYear,
      licenseEvaluation: this.licenseEvaluation, licenseFull: this.licenseFull,
    };
    let response = await ApiStore.call(this.api, this.api.getAll, payload);
    if (response) {
      runInAction(() => {
        this.updatePagingFiler(response.paging);
        this.tenants = response.elements;
        this.total = response.total;
        if (this.paging?.totalRecord && this.paging?.totalRecord !== 0) {
          if (this.paging?.page > 1 && (!response.elements || response.elements.length === 0)) {
            this.updatePagingFiler({ page: this.paging.page - 1 });
            this.getTenants();
          }
        }
      })
    }
  }

  @action
  async createTenant(payload, rb = null) {
    let resp = await ApiStore.call(this.api, this.api.createTenant, payload);
    if (resp) {
      return resp
    } else {
      rb && rb();
      return false;
    }
  }

  @action
  async updateTenant(payload, rb = null) {
    let resp = await ApiStore.call(this.api, this.api.updateTenant, payload);
    if (resp) {
      return resp
    } else {
      rb && rb();
      return false;
    }
  }

  @action
  clean() {
    if (!this.keepFilterState) {
      super.clean();
      this.fromMonth = (new Date()).getMonth() + 1;
      this.fromMonth = (new Date()).getMonth() + 1;
      this.toYear = (new Date()).getFullYear();
      this.toYear = (new Date()).getFullYear();
      this.active = 'true';
      this.renewalSpanMonth = 'true';
      this.renewalSpanYear = 'true';
      this.licenseEvaluation = 'true';
      this.licenseFull = 'true';
    }
  }
}

export default TenantStore;
